import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/theme-applied.css';
import './styles/responsive.css';
import App from './App';
import { applyMailSettings, getMailSettings } from './utils/mailSettings';
import { register as registerServiceWorker } from './serviceWorkerRegistration';

applyMailSettings(getMailSettings());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker();

